"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyHealing = void 0;
const __1 = require("../..");
const Duration_1 = require("../Duration");
const enums_1 = require("../enums");
const Calculators_1 = require("../state/Calculators");
const DefaultArgs = {
    attributePercent: 70,
    animate: false,
    onApplied: () => { },
};
function applyHealing(args) {
    args = {
        ...DefaultArgs,
        ...args,
    };
    const { healerId, targetId, amount, animate, attributePercent, onApplied } = args;
    let { sequence } = args;
    const [will, critChance, critMultiplier] = this.getAttributeScores(healerId, [
        enums_1.AttributeType.Will,
        enums_1.AttributeType.CriticalStrikeChance,
        enums_1.AttributeType.CriticalDamageMultiplier
    ]);
    let healingRoll = (0, Calculators_1.calculateHealing)(amount, Math.round(will * attributePercent / 100), critChance, critMultiplier);
    sequence = sequence.pushSequence("sequential");
    const healId = this.applyEffect(sequence, healerId, targetId, new __1.HealingEffectArgs(healingRoll.amount, healingRoll.crit, animate), Duration_1.Duration.Instant);
    const actual = this.getEffectMetaValue(healId, "Healing", "amount", 0);
    onApplied === null || onApplied === void 0 ? void 0 : onApplied(sequence, actual, healingRoll);
    return {
        amount: actual,
        healingRoll
    };
}
exports.applyHealing = applyHealing;
